import Alpine from "./Presentation/Universal";
import "./Helper/TextModifier";
import "./Presentation/Block/Event";
import "./Presentation/Section/Header";
import "./Presentation/Section/Footer";
import "./Presentation/Section/ArticlesNewestTeaser";
import lazySizes from "lazysizes";
import "lazysizes/plugins/bgset/ls.bgset";
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import "lazysizes/plugins/aspectratio/ls.aspectratio";
import "lazysizes/plugins/native-loading/ls.native-loading";

if (window.plausible) {
    document.addEventListener("prettyembed", (event) => {
        window.plausible("Video", { props: event.detail });
    });
}

lazySizes.cfg.nativeLoading = {
    disableListeners: {
        focus: true,
        mouseover: true,
        click: true,
        transitionend: true,
        animationend: true,
        scroll: true,
    },
};

window.Alpine = Alpine;

Alpine.start();
